import { LGoButton, LGoDialog } from "@/ui/branded";

interface RejectReservationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isRejecting: boolean;
  activityName: string;
}

export function RejectReservationDialog({
  open,
  onOpenChange,
  onConfirm,
  isRejecting,
  activityName,
}: RejectReservationDialogProps) {
  return (
    <LGoDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title="Odmítnout rezervaci?"
      description="Zákazníkovi nic nestrhneme a jeho částku uvolníme zpět. Kapacita této nabídky se okamžitě uvolní. O odmítnutí mu dáme vědět v aplikaci i e-mailem. Tuto akci nelze vzít zpět."
      loading={isRejecting}
      footer={
        <>
          <LGoButton variant="secondary" onClick={() => onOpenChange(false)}>
            Zpět
          </LGoButton>
          <LGoButton variant="destructive" onClick={onConfirm} loading={isRejecting}>
            Odmítnout rezervaci
          </LGoButton>
        </>
      }
    >
      <p className="text-sm font-medium text-foreground">{activityName}</p>
    </LGoDialog>
  );
}
